import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=48ab77d5&scoped=true"
import script from "./NewsModal.vue?vue&type=script&lang=js"
export * from "./NewsModal.vue?vue&type=script&lang=js"
import style0 from "./NewsModal.vue?vue&type=style&index=0&id=48ab77d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab77d5",
  null
  
)

export default component.exports